<template>
  <b-sidebar
    id="component-form-sidebar"
    :visible="isComponentFormSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="getData(componentData)"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-component-form-sidebar-active', val)"
  >
    <template #default="{ hide }"> 
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Component Form
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-tabs v-model="tabIndex">
            <b-tab title="Content">     
              <validation-provider
                #default="validationContext"
                name="title"
                rules="required"
              >
                <b-form-group
                  label="title"
                  label-for="title"
                >
                  <b-form-input
                    id="title"
                    v-model="Data.title"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="title"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider
                #default="validationContext"
                name="group_id"
                rules="required"
              >
                <b-form-group
                  label="Group"
                  label-for="group_id"
                >
                  <v-select
                    id="group_id"
                    v-model="Data.group_id"
                    label="title"
                    :reduce="(option) => option.id"
                    :options="groups"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider
                #default="validationContext"
                name="component"
                rules="required"
              >
                <b-form-group
                  label="component path"
                  label-for="component path"
                >
                  <b-form-input
                    id="component"
                    v-model="Data.component"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="component"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider
                #default="validationContext"
                name="short description"
              >
                <b-form-group
                  label="short description"
                  label-for="short description"
                >
                  <b-form-input
                    id="short_description"
                    v-model="Data.short_description"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    placeholder="short description"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider
                #default="validationContext"
                name="IsActive"
                rules="min:0"
              >
                <b-form-group
                  label="Is Active"
                  label-for="IsActive"
                >
                  <b-form-checkbox
                    id="isactive"
                    checked="true"
                    class="custom-control-success"
                    v-model="Data.is_active"
                    switch
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <div class="border rounded p-2">
                <h4 class="mb-1">Cover Image</h4>
                <b-media no-body vertical-align="center" class="flex-column flex-md-row">
                  <b-media-aside>
                    <b-img
                      ref="refPreviewEl"
                      :src="Data.fullpath?Data.fullpath:require('@/assets/images/no-image.png')"
                      height="110"
                      width="170"
                      class="rounded mr-2 mb-1 mb-md-0"
                    />
                  </b-media-aside>
                  <b-media-body>
                    <small class="text-muted">
                      Required image resolution 800x400, image size 10mb.
                    </small>
                    <b-card-text class="my-50"></b-card-text>
                    <div class="d-inline-block">
                      <b-form-file
                        ref="refInputEl"
                        v-model="Data.blogFile"
                        accept=".jpg, .png, .gif, .webp,"
                        placeholder="Choose file"
                        @input="inputImageRenderer"
                      />
                    </div>
                    <b-card-text class="my-50">
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        v-if="Data.cover_image"
                        @click="removeImage"
                      >
                        Remove Image
                      </b-button>
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </div>
            </b-tab>
            <b-tab title="Variable">
              <b-row
                v-for="(item, index) in items"
                :id="index"
                :key="index"
                ref="row"
              >
                <b-col md="3">
                  <validation-provider
                    #default="validationContext"
                    name="Title"
                    rules="required"
                  >
                    <b-form-group
                      label="Title"
                      label-for="title"
                    >
                      <b-form-input
                        :id="`item_title-${index}`"
                        v-model="item.title"
                        autofocus
                        :state="getValidationState(validationContext)"
                        trim
                        placeholder="title"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="3">
                  <validation-provider
                    #default="validationContext"
                    name="Type"
                    rules="required"
                  >
                    <b-form-group
                      label="Type"
                      label-for="type"
                    >
                      <v-select
                        :id="`type-${index}`"
                        v-model="item.type"
                        label="text"
                        :reduce="(option) => option.value"
                        :options="types_option"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="1">
                  <validation-provider
                    #default="validationContext"
                    name="Required"
                    rules="min:0"
                  >
                    <b-form-group
                      label="Required"
                      label-for="Required"
                    >
                      <b-form-checkbox
                        :id="`requireitem-${index}`"
                        checked="true"
                        class="custom-control-success"
                        v-model="item.required"
                        switch
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="1">
                  <validation-provider
                    #default="validationContext"
                    name="is_lang"
                    rules="min:0"
                  >
                    <b-form-group
                      label="Languages"
                      label-for="is_lang"
                    >
                      <b-form-checkbox
                        :id="`is_lang-${index}`"
                        checked="true"
                        class="custom-control-success"
                        v-model="item.is_lang"
                        switch
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Remove Button -->
                <b-col
                  lg="2"
                  md="3"
                  class="mb-50"
                >
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2"
                    @click="removeItem(index)"
                  >
                    <feather-icon
                      icon="XIcon"
                      class="mr-25"
                    />
                    <span>Delete</span>
                  </b-button>
                </b-col>
                <b-col cols="12">
                  <hr>
                </b-col>
              </b-row>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="repeateAgain"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Add New</span>
              </b-button>
            </b-tab>
          </b-tabs>
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Submit
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
       </validation-observer>
    </template>
  </b-sidebar>
</template>
<script>
import { $themeConfig } from '@themeConfig'
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton, BTabs, BTab,
  BRow, BCol, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile
} from 'bootstrap-vue'
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, onUnmounted } from '@vue/composition-api'
import { required, alpha_num, email, min, max } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import componentStoreModule from '../componentStoreModule'
import { quillEditor } from 'vue-quill-editor'

// Register VeeValidate validators
extend('required', required);
extend('alpha_num', alpha_num);
extend('email', email);
extend('min', min);
extend('max', max);

export default {
  components: {
    BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton, BTabs, BTab,
    BRow, BCol, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile, vSelect, quillEditor,
    ValidationProvider, ValidationObserver
  },

  directives: {
    Ripple,
  },

  model: {
    prop: 'isComponentFormSidebarActive',
    event: 'update:is-component-form-sidebar-active',
  },

  props: {
    isComponentFormSidebarActive: {
      type: Boolean,
      required: true,
    },
    componentData: {
      type: Object,
      required: false,
    },
  },

  setup(props, { emit }) {
    const {  appRef } = $themeConfig.app
    const types_option = ref([
      { text: 'text', value: 'text' },
      { text: 'textarea', value: 'textarea' },
      { text: 'editor', value: 'editor' },
      { text: 'Integer', value: 'Integer' },
      { text: 'banner', value: 'banner' },
      { text: 'images', value: 'images' },
      { text: 'blogs', value: 'blogs' },
      { text: 'blocks', value: 'blocks' },
      { text: 'table', value: 'table' },
      { text: 'comments', value: 'comments'}
    ]);
    const BlogInputContentRemove = ref([]);
    const toast = useToast()
    const tabIndex = ref(0);
    const groups = ref([]);
    const userStorage = JSON.parse(localStorage.getItem('userData'));
     
    const blankData = {
      created_by: userStorage.id,
      title: '',
      is_active: true,
      group_id: '',
      component: '',
      short_description: '',
      data: '',
      cover_image: '',
      featuredImage: '',
    }

    const COMMENT_STORE_MODULE_NAME = 'app-component';
    if (!store.hasModule(COMMENT_STORE_MODULE_NAME)) store.registerModule(COMMENT_STORE_MODULE_NAME, componentStoreModule);
    onUnmounted(() => {
      if (store.hasModule(COMMENT_STORE_MODULE_NAME)) store.unregisterModule(COMMENT_STORE_MODULE_NAME);
    });

    store.dispatch('app-component/fetchData', {})
      .then(response => {
        groups.value = response.data.data;
      });

    const Data = ref(JSON.parse(JSON.stringify(blankData)));
    const blankItemsData = [{
      id: '',
      title: '',
      type: '',
      required: false,
      created_by: userStorage.id,
    }];
     
    const items = ref(JSON.parse(JSON.stringify(blankItemsData)))

    const resetData = () => {
      Data.value = JSON.parse(JSON.stringify(blankData));
    };

    const getData = (data) => {
      tabIndex.value = 0;
      refPreviewEl.value.src = require("@/assets/images/no-image.png");

      if(!data) {
        return Data.value = JSON.parse(JSON.stringify(blankData))
      }

      data.is_active = data.is_active?true:false;
      data.featuredImage = data.cover_fullpath;
      Data.value  = JSON.parse(JSON.stringify(data));

      if(data.data){ 
        items.value  = JSON.parse(JSON.stringify(data.data));
      } else {
        items.value = JSON.parse(JSON.stringify(blankItemsData))
      }

      Data.value  = JSON.parse(JSON.stringify(data));
    };

    const onSubmit = () => {
      Data.value.is_active = Data.value.is_active ? 1 : 0;
      Data.value.data = JSON.stringify(items.value);

      const formData = new FormData();

      for (const [key, value] of Object.entries(Data.value)) {
        formData.append(key, value);
      }

      formData.append("count_conent_remove", BlogInputContentRemove.value.length);
      formData.append('path', '/var/www/html/uploadfiles/uploads/'+appRef+'/components/');
      formData.append('savepath', 'uploads/'+appRef+'/components/');

      if (Data.value.id) {
        store.dispatch('app-component/updateData', {
          formData: formData,
          data: Data.value,
        }).then((res) => {
          if (res.data.success) {
            toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Success`,
                icon: 'BellIcon',
                variant: 'success',
                text: `${res.data.message}`,
              },
            });
            emit('refetch-data');
            emit('update:is-component-form-sidebar-active', false);
          } else {
            toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Error`,
                icon: 'BellIcon',
                variant: 'danger',
                text: `${res.data.message}`,
              },
            });
          }
        });
      } else {
        store.dispatch('app-component/addData', formData)
          .then((res) => {
            if (res.data.success) {
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Success`,
                  icon: 'BellIcon',
                  variant: 'success',
                  text: `${res.data.message}`,
                },
              });
              emit('refetch-data');
              emit('update:is-component-form-sidebar-active', false);
            } else {
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Error`,
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: `${res.data.message}`,
                },
              });
            }
          });
        }
      };

    const checkRequired = () => {
      
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData);

    const refInputEl = ref(null);
    const refPreviewEl = ref(null);
    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        refPreviewEl.value.src = base64;
      }
    );

    const removeImage = () => {
      Data.value.featuredImage = require("@/assets/images/no-image.png");
      Data.value.cover_image = "";
    };

    return {
      groups,
      Data,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      getData,
      items,
      tabIndex,
      types_option,
      inputImageRenderer,
      removeImage,
      userStorage,
      refInputEl,
      refPreviewEl,
      checkRequired,
    }
  },

  methods: {
    repeateAgain() {
      this.items.push({
        id: '',
        is_active: true,
        type: '',
        required: false,
        created_by: this.userStorage.id,
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>